export default {
      id: "plus-usage",
      viewBox: "0 0 13 13",
      url: __webpack_public_path__ + "svgsprite.svg#plus",
      toString: function () {
        return this.url;
      }
    }